import { render, staticRenderFns } from "./VendorPaymentList.vue?vue&type=template&id=176dece5&"
import script from "./VendorPaymentList.vue?vue&type=script&lang=js&"
export * from "./VendorPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports